export const locale = {
  help: 'Charts guide'
};
